import { useProductListContext } from '../context/static/ProductListContext';

/**
 * A custom hook that provides a function to get the hexadecimal color code
 * based on the color name from the configuration.
 *
 * @returns {function(string): string} A function that takes a color name as an argument and
 * returns the corresponding hexadecimal color code. If the color name is not found,
 * it returns '#FFFFFF' by default.
 */
export const useColorCode = (): ((color: string) => string) => {
  const { colorCodeList } = useProductListContext();

  return (color = '') => colorCodeList.get(color.toLowerCase()) || '#ffffff';
};
